import moment from 'moment';

export default class BookStateHelper {
  static setAwaitingReview(book) {
    book.is_awaiting_review = true;
    book.is_canceled = false;
    book.status = 'Awaiting review';
  }

  static setBookState(book) {
    book.is_reviewed =  !!(book.review && book.review.state === 'published');
    book.is_in_review = !!(book.review && book.review.state === 'in_progress');
    book.is_awaiting_review = (book.status === 'Awaiting review');
    book.is_canceled = (book.status === 'Canceled');
    book.is_declined = (book.status === 'Declined');
    book.is_review_reported = !!(book.review && book.review.active_review_report !== null);
  }

  static setBooksListState(booksList) {
    booksList.forEach(BookStateHelper.setBookState);
    return booksList;
  }

  static setCanceled(book) {
    book.is_awaiting_review = false;
    book.is_canceled = true;
    book.is_live = false;
    book.status = 'Canceled';
  }

  static setPreorderStatus(book, preorderUrls) {
    let isPreorderable = false;

    if (preorderUrls.amazon) {
      book.amazon_purchase_url = {
        url: preorderUrls.amazon,
      };
      isPreorderable = true;
    } else {
      book.amazon_purchase_url = null;
    }

    if (preorderUrls.apple) {
      book.apple_purchase_url = {
        url: preorderUrls.apple,
      };
      isPreorderable = true;
    } else {
      book.apple_purchase_url = null;
    }

    if (preorderUrls.barnesAndNoble) {
      book.barnes_and_noble_purchase_url = {
        url: preorderUrls.barnesAndNoble,
      };
      isPreorderable = true;
    } else {
      book.barnes_and_noble_purchase_url = null;
    }

    if (preorderUrls.googlePlay) {
      book.google_play_purchase_url = {
        url: preorderUrls.googlePlay,
      };
      isPreorderable = true;
    } else {
      book.google_play_purchase_url = null;
    }

    if (preorderUrls.kobo) {
      book.kobo_purchase_url = {
        url: preorderUrls.kobo,
      };
      isPreorderable = true;
    } else {
      book.kobo_purchase_url = null;
    }

    if (preorderUrls.tertulia) {
      book.tertulia_purchase_url = {
        url: preorderUrls.tertulia,
      };
      isPreorderable = true;
    } else {
      book.tertulia_purchase_url = null;
    }

    if (preorderUrls.website) {
      isPreorderable = true;
    }

    book.website_url = preorderUrls.website;

    book.is_pre_orderable = isPreorderable;
  }

  static setReported(book, reviewReport) {
    book.is_review_reported = true;
    book.status = 'Review reported';
    book.review.active_review_report = {
      created_at: moment().format('ll'),
      description: reviewReport.description,
      reason: reviewReport.reason,
    };
  }
}
